import type { ActivityType } from '@/api/interfaces/time/settings/activity-types';
import apiClient from '@/helpers/client/api-client';
import {
  type AbortControllerInjectorReturn,
  useAbortControllerInjector,
} from '@/stores/composables/use-abort-controller-injector';

export function getTimeActivityTypes(): AbortControllerInjectorReturn<Array<ActivityType>> {
  return useAbortControllerInjector((abortController) => apiClient.get(
    '/time/v2/settings/activity-types',
    {
      signal: abortController.signal,
    },
  ));
}
